export default __webpack_public_path__ + "static/media/decor1.58a852bd.webp";